/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agenda_Source_Mirror_TitleInputs */



/**
* | output |
* | --- |
* | "It comes from your calendar" |
*
* @param {Agenda_Source_Mirror_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const agenda_source_mirror_title = /** @type {((inputs?: Agenda_Source_Mirror_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agenda_Source_Mirror_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Komt uit je agenda")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Il vient de votre agenda")
	return /** @type {LocalizedString} */ ("It comes from your calendar")
});